// extracted by mini-css-extract-plugin
module.exports = {"path":"z_bs","dash":"z_bt"};